import { render, staticRenderFns } from "./GalleryView.vue?vue&type=template&id=37068302&scoped=true&"
import script from "./GalleryView.vue?vue&type=script&lang=js&"
export * from "./GalleryView.vue?vue&type=script&lang=js&"
import style0 from "./GalleryView.vue?vue&type=style&index=0&id=37068302&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37068302",
  null
  
)

/* custom blocks */
import block0 from "./GalleryView.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37068302')) {
      api.createRecord('37068302', component.options)
    } else {
      api.reload('37068302', component.options)
    }
    module.hot.accept("./GalleryView.vue?vue&type=template&id=37068302&scoped=true&", function () {
      api.rerender('37068302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/GalleryView.vue"
export default component.exports